import React, { Component } from 'react'
import Section from '../shared/Section'
import Header from './Header'
import Questions from './Questions'
import { extendBaseClass } from '../../utils/classes'

export class Faq extends Component {
  baseClass = 'faq'

  extend = extendBaseClass.bind(this)

  render() {
    const content = this.extend('content')
    return (
      <Section extraClasses={this.baseClass}>
        <div className={content}>
          <Header parentClass={content} />
          <Questions parentClass={content} />
        </div>
      </Section>
    )
  }
}

export default Faq
